import { PRODUCT_PAGE } from "routes/route.constant";
import Product from "./Product";

const route = {
  path: PRODUCT_PAGE,
  element: Product,
};

export default route;
